module.exports = __webpack_public_path__ + "static/img/Frame1.e0deed02.png";